import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { CurrencyCode } from '../../typings/graphql-grid';
import { MoneyText } from '../MoneyText/MoneyText';
import { NumberText } from '../NumberText/NumberText';
import { ValueOrDash } from '../ValueOrDash/ValueOrDash';

import './GridTotalStats.css';

export interface GridTotalStatsProps {
    title?: string;
    description?: string;
    difference?: string;
    type?: string;
    currency?: CurrencyCode;
}

export enum TotalStatsTypes {
    COST = 'cost',
    CLICKS = 'clicks',
    SHOWS = 'shows',
    CTR = 'ctr'
}

export class GridTotalStats extends React.PureComponent<GridTotalStatsProps> {
    render() {
        const { title, type, difference } = this.props;

        return (
            <div className={Bem.cls('grid-screen-total-stats')}>
                <span className={Bem.cls('grid-screen-total-stats', 'title')}>{title}</span>
                <div className={Bem.cls('grid-screen-total-stats', 'description')}>{this.getTextStat()}</div>
                {difference && (
                    <span
                        className={Bem.cls('grid-screen-total-stats', 'difference', {
                            type: type ? Bem.beminize(type) : undefined
                        })}
                    >
                        {difference}
                    </span>
                )}
            </div>
        );
    }

    private getTextStat() {
        const { type, description, currency } = this.props;

        switch (type) {
            case TotalStatsTypes.CLICKS:
            case TotalStatsTypes.SHOWS:
                return (
                    <ValueOrDash value={description}>
                        {description && <NumberText num={Number(description)} fractionalPartLength={0} />}
                    </ValueOrDash>
                );
            case TotalStatsTypes.COST:
                return (
                    <ValueOrDash value={description}>
                        {description && (
                            <MoneyText
                                num={Number(description)}
                                fractionalPartLength={2}
                                currency={currency === undefined ? undefined : mapStringToCurrencySymbol(currency)}
                            />
                        )}
                    </ValueOrDash>
                );
            case TotalStatsTypes.CTR:
                return (
                    <ValueOrDash value={description}>
                        <NumberText num={Number(description)} fractionalPartLength={2} />%
                    </ValueOrDash>
                );
            default:
                return description;
        }
    }
}
